// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./pages/onko/onko.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
